import { render, staticRenderFns } from "./SingleBook.vue?vue&type=template&id=ddf00ba8"
import script from "./SingleBook.vue?vue&type=script&lang=js"
export * from "./SingleBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports